import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { MenuItemDeleteCard } from './components/MenuItemDeleteCard';
import { MenuItemDetailsCard } from './components/MenuItemDetailsCard';

export function MenuItemDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const menuItemQueryResults = useQuery({
        queryKey: ['menuItem', id],
        queryFn: () => Api.Menu.MenuItem.getMenuItem(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={menuItemQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <MenuItemDetailsCard menuItem={data} />

                        <Can I="delete" a="MenuItem">
                            <MenuItemDeleteCard menuItem={data} />
                        </Can>
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
